export default __webpack_public_path__ + "static/PEPRESSIONISM-583a008bff9174f8c73ad48b393271f7.png";